import { AccountType } from '@/autogenerated/@prisma/prisma-mongo-client';

export const userTypeOptions = ['local', 'newcomer'] as const;
export const usertypeToAccountTypeMapping: Record<
  (typeof userTypeOptions)[number],
  AccountType
> = {
  local: AccountType.Supporter,
  newcomer: AccountType.Refugee,
};
export function userTypeToAccountType(
  userType: string | null
): AccountType | undefined {
  if (!userType) return undefined;

  return userType in usertypeToAccountTypeMapping
    ? usertypeToAccountTypeMapping[
        userType as keyof typeof usertypeToAccountTypeMapping
      ]
    : undefined;
}
